interface NarrowDetectableConceptType {
  baseXbrliType?: string | null;
  typeQname?: string | null;
}

const localPart = (qname: string | null | undefined): string | null => {
  if (!qname) return null;
  const afterBrace = qname.includes('}') ? qname.slice(qname.lastIndexOf('}') + 1) : qname;
  return afterBrace.includes(':') ? afterBrace.slice(afterBrace.lastIndexOf(':') + 1) : afterBrace;
};

const ESCAPED_SPECIFIC_TYPES = new Set(['textBlockItemType', 'escapedItemType', 'xmlNodesItemType', 'xmlItemType']);

export const getConceptNarrowType = (conceptType: NarrowDetectableConceptType | null | undefined): string | null => {
  if (!conceptType) return null;
  return localPart(conceptType.typeQname) ?? localPart(conceptType.baseXbrliType);
};

export const isEscapedConceptType = (conceptType: NarrowDetectableConceptType | null | undefined): boolean => {
  const specific = getConceptNarrowType(conceptType);
  return specific !== null && ESCAPED_SPECIFIC_TYPES.has(specific);
};
